import { FunctionComponent, useCallback, useMemo } from "react";
import * as React from "react";
import classNames from "classnames";

import { Link } from "@ppb/the-wall-web";
import { useIsExchangeProduct } from "../../hooks/useIsExchangeProduct";
import { i18n } from "../../helpers/i18n";
import { toTheWallViewLink } from "../../helpers/view-link-adapters";
import { ComponentProps } from "./props";
import styles from "./OpenBets.web.css";

export const OpenBets: FunctionComponent<ComponentProps> = ({ viewLink, dispatchOpenBetsNavigation }) => {
  // Open Bets is an Exchange-only concept (back/lay liability on a matched bet), so it must stay
  // invisible - not even the disabled label - everywhere else: Sportsbook, or a brand with no
  // Exchange product at all (PP, SBG). Checked here rather than per-caller because some callers
  // (PebbleCardGroup's OpenBetsSlot, RaceMeetingView's OpenBet) render this component directly,
  // bypassing ConnectedOpenBets, so a check in its map-to-props-factory wouldn't cover them.
  const isExchangeProduct = useIsExchangeProduct();
  const onOpenBetsPress = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();

      return viewLink && dispatchOpenBetsNavigation(viewLink);
    },
    [dispatchOpenBetsNavigation, viewLink],
  );
  const item = useMemo(() => ({ viewLink: viewLink && toTheWallViewLink(viewLink), isTextLink: true }), [viewLink]);
  const label = useMemo(() => i18n({ key: "I18N.OPEN_BETS.LINK" }), []);

  if (!isExchangeProduct) {
    return null;
  }

  // Link's fallback (no viewLink) render path is a bare <button> with no
  // button-chrome reset, so the disabled state renders as plain text instead.
  if (!viewLink) {
    return <span className={classNames(styles.openBets, styles.disabled)}>{label}</span>;
  }

  return (
    <Link item={item} onClick={onOpenBetsPress}>
      <span className={styles.openBets}>{label}</span>
    </Link>
  );
};
